<script setup>
import { reactive, watch } from 'vue'

const props = defineProps({
    node: Object,
})

const emit = defineEmits(['update:config'])

const eventTypes = [
    { value: 'email_opened', label: 'Email Opened' },
    { value: 'email_clicked', label: 'Email Clicked' },
    { value: 'form_submitted', label: 'Form Submitted' },
    { value: 'page_visited', label: 'Page Visited' },
    { value: 'tag_assigned', label: 'Tag Assigned' },
    { value: 'field_changed', label: 'Field Changed' },
]

const form = reactive({
    event_type: props.node?.data?.config?.event_type ?? '',
    timeout_hours: props.node?.data?.config?.timeout_hours ?? 24,
})

watch(() => props.node, (node) => {
    if (!node) return
    form.event_type = node.data?.config?.event_type ?? ''
    form.timeout_hours = node.data?.config?.timeout_hours ?? 24
})

function emitUpdate() {
    emit('update:config', { event_type: form.event_type, timeout_hours: Number(form.timeout_hours) })
}
</script>

<template>
    <div class="config-panel__section">
        <label class="config-panel__label">Wait For Event</label>
        <select v-model="form.event_type" class="config-panel__select" @change="emitUpdate">
            <option value="">— Select event —</option>
            <option v-for="e in eventTypes" :key="e.value" :value="e.value">{{ e.label }}</option>
        </select>

        <label class="config-panel__label">Timeout (hours)</label>
        <input
            v-model="form.timeout_hours"
            class="config-panel__input"
            type="number"
            min="1"
            placeholder="24"
            @input="emitUpdate"
        />
        <p class="config-panel__hint">If the event doesn't occur within the timeout, flow continues via the Timeout branch.</p>
    </div>
</template>
